import { Outlet, createFileRoute } from '@tanstack/react-router'

import { StudentAppNavigationTabsCompanyLearning } from '@/app/student/StudentAppNavigationTabsCompanyLearning'
import StudentAppPagePadding from '@/app/student/StudentAppPagePadding'
import DashboardPage from '@/dashboard/components/DashboardPage/DashboardPage'

export const Route = createFileRoute('/_learning/_company')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <StudentAppNavigationTabsCompanyLearning>
      <DashboardPage>
        <StudentAppPagePadding>
          <Outlet />
        </StudentAppPagePadding>
      </DashboardPage>
    </StudentAppNavigationTabsCompanyLearning>
  )
}
